/* eslint @typescript-eslint/no-explicit-any: 0 */

import { useCallback, useState } from 'react';

export function useModal() {
  const [isOpen, setOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  return [
    isOpen,
    useCallback((event: any) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      setScrollY(window.pageYOffset);
      setOpen(true);
    }, []),
    useCallback(
      (event: any) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (isOpen) {
          window.scroll(0, scrollY);
          setScrollY(0);
        }

        isOpen && setOpen(false);
      },
      [isOpen, scrollY]
    )
  ] as [boolean, any, any];
}
